import React from 'react'

export default function Content() {
  return (
   
    <>
     
     <div className='col-md-10 content'>

     <iframe width="560" height="315" src="https://www.youtube.com/embed/qz0aGYrrlhU?si=wLile1miCbAeejBl" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

     </div>
    
    </>
  )
}
